module.exports = __webpack_public_path__ + "static/media/pencil-active.b6bbd8e2.svg";